import React from "react";
import PropTypes from "prop-types";
import {Paper, Typography, Box} from "@material-ui/core";
import clsx from "classnames";

import {useStyles} from "../../hooks";
import styles from "./styles";
import {Link} from "react-router-dom";

const CardProducts = ({icon: Icon, id, label, borderRadius = "all"}) => {
  const classes = useStyles(styles);
  
  return (
    <Link to={`/st/productos/${id}`} style={{color: 'inherit', textDecoration: 'inherit'}}>
      <Paper
        className={clsx(classes.root, {
          [classes.allBorderRadius]: borderRadius === "all",
          [classes.noBorderTopLeftRadius]: borderRadius === "not-top-left",
          [classes.noBorderTopRightRadius]: borderRadius === "not-top-right",
          [classes.noBorderBottomRightRadius]:
          borderRadius === "not-bottom-right",
          [classes.noBorderBottomLeftRadius]: borderRadius === "not-bottom-left"
        })}
        elevation={0}
      >
        
          <Icon className={classes.icon}/>
          <Typography variant="subtitle1" component="h4" className={classes.text} style= {label === "Petróleo, Gas y Minería" ? {marginTop: '-2px'} : {}}>
            {label}
          </Typography>
          <Box className={label === "Petróleo, Gas y Minería" ? classes.backgroundIconPgm : classes.backgroundIcon}>
            <Icon className={classes.icon}/>
          </Box>
      </Paper>
    </Link>
  );
};

CardProducts.propTypes = {
  id: PropTypes.string.isRequired,
  icon: PropTypes.elementType.isRequired,
  label: PropTypes.string.isRequired,
  borderRadius: PropTypes.oneOf([
    "not-top-left",
    "not-top-right",
    "not-bottom-right",
    "not-bottom-left",
    "all"
  ])
};

export default CardProducts;
